export * from './mSGMClient1.service';
import { MSGMClient1Service } from './mSGMClient1.service';
export * from './mSGMPublic1.service';
import { MSGMPublic1Service } from './mSGMPublic1.service';
export const APIS = [MSGMClient1Service, MSGMPublic1Service];
